/*  =============================================
    Copyright © Hugo B.V. (acting under the brand name "Quriobot") - All Rights Reserved
    =============================================

    - Unauthorized copying of this file, via any medium is strictly prohibited
    - Proprietary and confidential
    - By using the Quriobot Website and/or Services, you signify you have read and
      accepted the Terms of Service on https://quriobot.com/terms of this Website and Services.
      If you do not agree to these Conditions, do not use Quriobot Website and/or Services.
    - Written by the good people of Hugo B.V. (acting under the brand name "Quriobot"), hello@quriobot.com, December 2016

    ============================================= */

var PanelOptions = new Class({
  Extends: QuriobotElement,
  template: function () {
    var base =
      '<div class="panel--wrapper panel--multi isLoading{% button-state %}" family="{{ key }}" id="{{ eid }}">' +
      '    <div class="panel--main">' +
      '        <div class="panel--content">' +
      '            <div class="panel--options">' +
      '                <div class="panel--optionsInner">' +
      '                    <div class="panel--arrow arrow--up"><span class="arrow"></span></div>' +
      '                    <ul role="listbox" class="panel--options__list">' +
      '                        {% options %}' +
      '                    </ul>' +
      '                    <div class="panel--arrow arrow--down"><span class="arrow"></span></div>' +
      '                </div>' +
      '            </div>' +
      '            {% button %}' +
      '        </div>' +
      '        <div class="panel--overlay">' +
      '            <div class="icon--checkWrapper fromBottom circle">' +
      '                <div class="check"></div>' +
      '            </div>' +
      '            <button type="button" aria-label="' +
      this.data.i18n.redo.button.title +
      '" aria-hidden="true" class="icon--redoWrapper">' +
      '                <div class="redo"></div>' +
      '            </button>' +
      '        </div>' +
      '    </div>' +
      '</div>'

    var option =
      '<li role="option" aria-selected="false" class="option {{^icon}}{{#image_before}}image_before{{/image_before}}{{/icon}} {{#icon}}image_before{{/icon}} {{#comment}}with-comment{{/comment}}" data-option-id="{{ id }}" data-url="{{ url }}" data-url-target="{{ urlTarget }}">' +
      '   {{^icon}}{{#image_before}}<div class="option--image-before"><img src="{{ image_before }}" /></div>{{/image_before}}{{/icon}}' +
      '   {{#icon}}<div class="option--image-before"><span class="fas fa-{{ icon }}"></span></div>{{/icon}}' +
      '   <div class="option--text">' +
      '       <span class="option--text--content">{{{ text }}}</span>' +
      '       {{#comment}}<span class="option--comment">{{{ comment }}}</span>{{/comment}}' +
      '   </div>' +
      '   <div class="icon--checkWrapper dark atLeft fast">' +
      '       <div class="check-outline"><span></span></div>' +
      '       <div class="check"></div>' +
      '   </div>' +
      '</li>'

    var button =
      '<div class="panel--done">' +
      '   <button type="submit" class="done--button" aria-label="{% go_button_text %}">' +
      //                     '       <div class="button--text">{% go_button_text %}</div>'+
      '        <div class="button--arrow"></div>' +
      '   </button>' +
      '</div>'

    return { base: base, option: option, button: button }
  },
  attach: function () {
    var optionsWrapper = this.element.getElements('.panel--optionsInner')[0],
      optionsList = optionsWrapper.getElements('ul')[0]

    var Allowed = this.data.choices
    var Options = this.element.getElements('li.option')
    if (this.data.meta.optionsLayout === 'grid') {
      optionsList.addClass('panel--options__list_type_grid')
      optionsWrapper.addClass('panel--optionsInner_type_grid')
      if (typeof this.data.meta.minOptionWidth === 'number') {
        Options.setStyle('min-width', this.data.meta.minOptionWidth)
      }
    } else if (optionsList.getSize().y > optionsWrapper.getSize().y) {
      optionsWrapper.addClass('hasScroll')
    }
    var Done = this.element.getElements('.done--button')
    var List = this.element.getElements('.panel--options__list')

    var maxChoices = this.data.choices || this.data.meta.max

    if (maxChoices > 1) {
      List[0].set({
        'aria-multiselectable': true,
      })
    }

    this.selected = {
      values: [],
      content: [],
    }

    if (Options.length) {
      Options.each(
        function (oOption, i) {
          var url = oOption.get('data-url')
          if (url) {
            this.quriobot.populateURL(
              url,
              function (url) {
                oOption.set('data-url', url)
              }.bind(this)
            )
          }
          oOption.addEvents({
            click: function () {
              var Selected = this.element.getElements('li.option.selected--option')
              var url = oOption.get('data-url')
              var urlTarget = oOption.get('data-url-target')

              if (maxChoices > 1) {
                if (oOption.hasClass('selected--option')) {
                  oOption.removeClass('selected--option')
                  oOption.set('aria-selected', false)
                  this.selected.values.erase(oOption.get('data-option-id'))
                  this.selected.content.erase(oOption.getElements('.option--text--content')[0].get('text'))
                } else {
                  if (maxChoices > Selected.length) {
                    oOption.addClass('selected--option')
                    oOption.set('aria-selected', true)
                    this.selected.values.push(oOption.get('data-option-id'))
                    this.selected.content.push(oOption.getElements('.option--text--content')[0].get('text'))
                    this.openURL(url, urlTarget)
                    // finish
                    if (maxChoices === Selected.length + 1) {
                      this.after()
                    }
                  }
                }
              } else {
                if (!oOption.hasClass('selected--option')) {
                  Selected.removeClass('selected--option')
                  Selected.set('aria-selected', false)
                  oOption.addClass('selected--option')
                  oOption.set('aria-selected', true)
                  this.selected.values = []
                  this.selected.content = []
                  this.selected.values.push(oOption.get('data-option-id'))
                  this.selected.content.push(oOption.getElements('.option--text--content')[0].get('text'))
                  this.openURL(url, urlTarget)
                  this.after()
                } else {
                  Selected.removeClass('selected--option')
                  Selected.set('aria-selected', false)
                }
              }
            }.bind(this),
          })
        }.bind(this)
      )
    }

    if (Done.length) {
      Done.each(
        function (oDone, i) {
          oDone.addEvents({
            click: function () {
              if (this.element.getElements('.selected--option').length >= 1 || this.data.is_required === false) {
                this.after()
              }
            }.bind(this),
          })
        }.bind(this)
      )
    }

    if (this.element.getElements('.hasScroll').length) {
      var wrapper = this.element.getElements('.hasScroll'),
        list = this.element.getElements('.hasScroll ul'),
        arrowUp = this.element.getElements('.arrow--up'),
        arrowDown = this.element.getElements('.arrow--down')

      function onScroll() {
        var wrapperScrollTop = wrapper[0].scrollTop
        arrowUp.toggleClass('active', wrapperScrollTop > 0)
        arrowDown.toggleClass('active', list[0].offsetHeight > wrapperScrollTop + wrapper[0].offsetHeight)
      }
      onScroll()

      wrapper.addEvents({
        scroll: function () {
          onScroll()
        }.bind(this),
      })

      arrowUp.addEvents({
        click: function () {
          var wrapperScrollTop = wrapper[0].scrollTop
          var scrollTopArrow = new Fx.Scroll(wrapper[0], {
            offset: {
              x: 0,
              y: wrapperScrollTop > 100 ? wrapperScrollTop - 100 : 0,
            },
          }).toTop()
        },
      })

      arrowDown.addEvents({
        click: function () {
          var wrapperScrollTop = wrapper[0].scrollTop
          var scrollTopArrow = new Fx.Scroll(wrapper[0], {
            offset: {
              x: 0,
              y: wrapperScrollTop + 100,
            },
          }).toTop()
        },
      })
    }
  },
  populate: function (result) {
    if (this.data.meta && this.data.meta.getOptionsScript) {
      this.getOptionsCallback(
        this.data.meta.getOptionsScript,
        null,
        function (options) {
          if (options) {
            this.data.options = options.map(function (item) {
              return {
                image_before: item.image,
                icon: item.icon,
                id: item.value,
                text: item.label,
                url: item.url || '',
                urlTarget: item.urlTarget || '',
              }
            })
            QuriobotElement.prototype.populate.bind(this)(result)
          }
        }.bind(this)
      )
    } else {
      return QuriobotElement.prototype.populate.bind(this)(result)
    }
  },
  after: function () {
    this.element.getElements('.panel--options__list')[0].set({
      'aria-disabled': true,
    })

    var answerData = {
      answer: {
        render: false,
        value: this.selected.values,
        content: this.selected.content,
      },
    }
    this.element.addClass('isAnswered')
    this.answerCallback(this.data, answerData)

    // Add `aria-hidden="true"` after answering to the question
    this.setAriaHidden('.panel--options__list', true)

    // Remove `aria-hidden="true"` from redo-button
    this.setAriaHidden('.icon--redoWrapper', false)
  }
})
